import { useState } from "react";
import { useLocation } from "react-router-dom";
import { FileDown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { download } from "@/lib/admin";
import { can } from "@/lib/perms";

const MODULE = { panoramica: "panoramica", analisi: "analisi", territori: "territori", aziende: "aziende", azienda: "aziende", sedi: "sedi", analytics: "analytics", registro: "registro" };

export const ReportButtons = ({ section, drop = [], extra = {} }) => {
    const { user } = useAuth();
    const { search } = useLocation();
    const [msg, setMsg] = useState("");
    if (!can(user, MODULE[section]) || !can(user, "download", "C")) return null;
    const go = async (format) => {
        const qs = new URLSearchParams(search);
        ["page", "vista", ...drop].forEach((k) => qs.delete(k));
        Object.entries(extra).forEach(([k, v]) => qs.set(k, v));
        qs.set("format", format);
        setMsg("Generazione del report in corso…");
        try { setMsg(`File scaricato: ${await download(`/admin/reports/${section}?${qs}`)}`); } catch { setMsg("Download del report non riuscito, riprova"); }
    };
    return (
        <div className="flex flex-wrap items-center gap-2" role="group" aria-labelledby={`report-${section}-label`} data-testid={`report-${section}`}>
            <span id={`report-${section}-label`} className="inline-flex items-center gap-1.5 font-semibold"><FileDown aria-hidden="true" size={18} /> Scarica report</span>
            {["pdf", "csv", "xml"].map((f) => (
                <button key={f} type="button" className="btn-secondary py-2 px-4" onClick={() => go(f)} aria-label={`Scarica report ${f.toUpperCase()}`} data-testid={`report-${section}-${f}`}>{f.toUpperCase()}</button>
            ))}
            <p role="status" aria-live="polite" className="text-sm w-full" data-testid={`report-${section}-status`}>{msg}</p>
        </div>
    );
};
